/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState, useCallback, useEffect, ReactNode} from "react";

import Room from "./Room";
import API from "../../helpers/apiHelpers";
import {Box, Dialog, IconButton, useMediaQuery} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {useHistory} from "react-router-dom";
import moment from "moment-timezone";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {patchAppointment} from "../../redux/appointment/appointment.actions";
import deviceChecker from "../../utils/deviceChecker";
import publicIp from "public-ip";
import {getUserLocation} from "../../redux/user/user.actions";
import Chat from "../../Pages/Chat";
import {useTheme} from "@material-ui/core/styles";
import Call from "./Call";
import useAgora from "../../hooks/useAgora";
import AgoraRTC from "agora-rtc-sdk-ng";
import {getCookie} from "../../helpers/cookieHelpers";

const client = AgoraRTC.createClient({codec: "vp8", mode: "rtc"});


const VideoChat = (props: {
        data: any,
        vet: any,
        closeChat: (open, data, over) => void,
        appointmentId: any,
        isVet: boolean,
        isTranscript: boolean,
        over: boolean,
        closeTranscript: () => void,
        isJoin?: string,
        videoChatIsClosed?: null | string,
        setVideoChatIsClosed?: (string) => void,
    }) => {
    const {
        data,
        vet,
        closeChat,
        appointmentId,
        isVet,
        over,
        closeTranscript,
        isTranscript,
        isJoin,
        setVideoChatIsClosed,
        videoChatIsClosed
    } = props;
    const history = useHistory();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const animalId = data?.animalId || data?.animal?.id;
    const [roomName, setRoomName] = useState("any-channel");
    const [token, setToken] = useState(undefined);
    const [identity, setIdentity] = useState(undefined);
    const [showCheck, setShowCheck] = useState(undefined);
    const user = useSelector((state: RootState) => state?.user);
    const [displayChat, setDisplayChat] = useState(false);
    let isBottomNav = useMediaQuery("(max-width:765px)");
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    const agoraService = useAgora(client);
    const {
        localAudioTrack,
        localVideoTrack,
        joinState,
        leave,
        join,
        remoteUsers,
        audioDevices,
        videoDevices,
        audioDevice,
        videoDevice,
        updateAudioInput,
        updateVideoInput,
    } = agoraService;


    useEffect(() => {
        (async () => {
            const {token, roomId, identity} = await API.getAgorakeys(appointmentId);
            setRoomName(roomId);
            setIdentity(identity);
            setToken(token);
        })();
    }, []);

    useEffect(() => {
        const checkSession = () => {
            if (getCookie("visited") === "yes") {
                setShowCheck(false);
            } else {
                setShowCheck(true);
            }
        };
        checkSession();
    }, []);

    useEffect(() => {
        (async () => {
            if (user.role === "OWNER") {
                const ip = await publicIp.v4();
                const userLocation = await dispatch(getUserLocation(ip));
                dispatch(patchAppointment(appointmentId, {
                    zipCode: userLocation.zip,
                    device: deviceChecker()
                }));
            } else if (user.role === "VET") {
                const tz = moment.tz.guess();
                const time = moment.tz(moment(), tz);
                await dispatch(patchAppointment(appointmentId, {
                    actualStartTime: time.format()
                }));
            }
        })();
    }, []);

    const handleLogout = () => {
        leave();
        setVideoChatIsClosed("logout");
    };

    const handleClose = () => {
        leave();
        setVideoChatIsClosed("close");
    };
    const handleCloseChatModal = () => {
        setDisplayChat(false);
    };

    let render;
    if (token) {
        render = (
            <Box marginTop="20px">
                {isVet ? null : (
                    <Box position="fixed" right="30px" top="45px">
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon fontSize="large"/>
                        </IconButton>
                    </Box>
                )}
                <Call
                    token={token}
                    channel={roomName}
                    identity={identity}
                    agoraService={agoraService}
                    handleLogout={handleLogout}
                    showCheckArr={[showCheck, setShowCheck]}
                    setDisplayChat={setDisplayChat}
                />
                {typeof joinState === "boolean"
                    &&
                    (isMobile && !isVet
                        ?
                        <Dialog
                            fullScreen
                            open
                            style={{display: displayChat ? "block" : "none"}}
                        >
                            <Box position="fixed" right="5px">
                                <IconButton edge="start" color="inherit" onClick={handleCloseChatModal}
                                    aria-label="close">
                                    <CloseIcon fontSize="large"/>
                                </IconButton>
                            </Box>
                            <Chat closeChat={closeChat}
                                closeTranscript={closeTranscript}
                                data={data}
                                vet={vet}
                                over={over}
                                appointmentId={appointmentId}
                                isVet={isVet}
                                isTranscript={isTranscript}
                                isVideo
                                chatClosed={videoChatIsClosed}
                                setVideoToken={setToken}
                                setDisplayChat={setDisplayChat}
                                handleClose={handleClose}
                                isJoin={isJoin}
                            />
                        </Dialog>
                        :
                        <Chat closeChat={closeChat}
                            closeTranscript={closeTranscript}
                            data={data}
                            vet={vet}
                            over={over}
                            appointmentId={appointmentId}
                            isVet={isVet}
                            isTranscript={isTranscript}
                            isVideo
                            chatClosed={videoChatIsClosed}
                            setVideoToken={setToken}
                            handleClose={handleClose}
                            isJoin={isJoin}
                        />
                    )}
            </Box>
        );
    } else {
        render = (
            <Box paddingTop="100px">
                <h1></h1>
            </Box>
        );
    }
    return render;
}
;

export default VideoChat;

